import React, { useState } from 'react';
import { Divider, message, Modal, Typography } from 'antd';
import { FileSoundRecord, FileVideoRecord, logo } from '../../assets';
import { QaDetailMainInfor, TicketDetail } from '../../types';
import { qaIntegrationMessage } from '../../messages';
import dayjs from 'dayjs';

type QaIntegrationDetailInformationProps = {
  evaluationId: number;
  qaIntegrationCreateMainInformationDto: QaDetailMainInfor;
  detail: TicketDetail;
};

const QaIntegrationDetailInformation: React.FC<QaIntegrationDetailInformationProps> = ({
  qaIntegrationCreateMainInformationDto: data,
  detail
}) => {
  const [isPreviewVisible, setIsPreviewVisible] = useState<boolean>(false);

  const playAudio = () => {
    if (!data.recordingLink) {
      message.error('Không có file âm thanh');
      return;
    }
    const audio = new Audio(data.recordingLink);
    audio
      .play()
      .then(() => {
        console.log('Play sound: ', data.recordingLink);
      })
      .catch((error) => {
        message.error('Không thể phát âm thanh');
      });
  };

  return (
    <div className='h-[calc(95vh-4rem)] w-full overflow-y-auto rounded-bl-xl border-t-2 bg-[#f5f5f7] p-6'>
      <section>
        <Typography.Text className={'text-[18px]/[22px] font-semibold'}>
          {qaIntegrationMessage.qaIntegrationInformationTitle}
        </Typography.Text>
      </section>

      <section className={'mt-[20px]'}>
        <div className='mt-[0px] space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>
            {qaIntegrationMessage.evaluationDate}
          </Typography.Text>
          <br />
          <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
            {data?.evaluationDate && dayjs(data?.evaluationDate).format('DD/MM/YYYY, HH:mm:ss')}
          </Typography.Text>
        </div>
        <div className='mt-[0px] space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>
            {qaIntegrationMessage.fileRecord}
          </Typography.Text>
          <br />
          <div onClick={() => playAudio()} className={'cursor-pointer'}>
            <Typography.Text className='flex items-center gap-2 text-[16px]/[20px] text-[#141414] hover:font-semibold hover:text-[#1564E8]'>
              <div className={'w-fit rounded-full border border-[#1564E8] p-1'}>
                <FileSoundRecord />
              </div>
              {qaIntegrationMessage.playFileRecord}
              {/*{data?.videoLink || ''}*/}
            </Typography.Text>
          </div>
        </div>
        <div onClick={() => setIsPreviewVisible(true)} className='mt-[0px] space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>
            {qaIntegrationMessage.videoRecord}
          </Typography.Text>
          <br />
          <div className={'cursor-pointer'}>
            <Typography.Text className='flex items-center gap-2 text-[16px]/[20px] text-[#141414] hover:font-semibold hover:text-[#1564E8]'>
              <div className={'w-fit rounded-full border border-[#1564E8] p-1'}>
                <FileVideoRecord />
              </div>
              {qaIntegrationMessage.playVideoRecord}
            </Typography.Text>
          </div>
        </div>
        <div className='mt-[0px] space-y-2'>
          <Typography.Text className='text-[12px]/[16px] text-[#6C737E]'>
            {qaIntegrationMessage.completionDate}
          </Typography.Text>
          <br />
          <Typography.Text className='text-[16px]/[20px] text-[#141414]'>
            {data?.completionDate && dayjs(data?.completionDate).format('DD/MM/YYYY, HH:mm:ss')}
          </Typography.Text>
        </div>
      </section>
      <Divider className={'my-[5px] mt-[17px] bg-[#D4D8DE]'} />

      <section className={'mt-[15px]'}>
        <Typography.Text className={'text-[18px]/[22px] font-semibold'}>
          {qaIntegrationMessage.ticketInformation}
        </Typography.Text>
        <div className='detail-card mt-[20px] rounded-lg border p-4'>
          <div>
            <Typography.Text className='mb-1 text-[12px]/[16px] text-[#FFFFFFCC]'>
              #{detail?.ticketId || ''}
            </Typography.Text>
            <br />
            <Typography.Text className='mb-1 text-[14px]/[18px] font-semibold text-[#FFFFFF]'>
              {detail?.serviceType?.name || ''}
            </Typography.Text>
          </div>

          <div className={'mt-[15px]'}>
            <div className={'flex items-center gap-2'}>
              <img src={logo} className='logo-fade-in h-6 w-6' alt={''} />
              <Typography.Text className='mb-1 text-[14px]/[18px] font-semibold text-[#FFFFFF]'>
                {detail?.customerCode || ''}
              </Typography.Text>
            </div>
          </div>

          <div className={'mt-[15px]'}>
            <div className={'flex justify-between gap-4'}>
              <div className={''}>
                <Typography.Text className='mb-1 text-[12px]/[16px] text-[#FFFFFFCC]'>Người liên hệ</Typography.Text>
                <br />
                <Typography.Text className='mb-1 text-[14px]/[18px] font-semibold text-[#FFFFFF]'>
                  {detail?.customerRequestName || ''}
                </Typography.Text>
              </div>

              <div className={'w-[50%] text-end'}>
                <Typography.Text className='mb-1 text-[12px]/[16px] text-[#FFFFFFCC]'>Ngày tiếp nhận</Typography.Text>
                <br />
                <Typography.Text className='mb-1 text-[14px]/[18px] font-semibold text-[#FFFFFF]'>
                  {detail?.receptionDate ? dayjs(detail?.receptionDate).format('DD/MM/YYYY') : '-'}
                </Typography.Text>
              </div>
            </div>

            <div className={'mt-[15px] gap-2'}>
              <Typography.Text className='mb-1 text-[12px]/[16px] text-[#FFFFFFCC]'>Địa chỉ</Typography.Text>
              <br />
              <Typography.Text className='mb-1 text-[14px]/[18px] font-semibold text-[#FFFFFF]'>
                {detail?.customerRequestAddress || '-'}
              </Typography.Text>
            </div>
          </div>
        </div>
      </section>

      <Modal
        open={isPreviewVisible}
        onCancel={() => setIsPreviewVisible(false)}
        footer={null}
        width={1200}
        centered
        styles={{
          body: {
            paddingTop: '50px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }
        }}
      >
        <video
          controls
          style={{
            width: '100%',
            maxHeight: '80vh'
          }}
          src={data.videoLink}
        />
      </Modal>
    </div>
  );
};

export default QaIntegrationDetailInformation;
